import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, Paper, TableFooter, TablePagination, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { MessageRounded } from "@material-ui/icons";
import FileOpenIcon from '@mui/icons-material/FileOpen';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import TaskIcon from '@mui/icons-material/Task';
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Api from "../../../helpers/api";
import TicketCommentsModal from "../Components/Comments/runplanStatus";
import {
    createRunPlan,
    getRunPlan, uploadMediaFiles
} from "../store/actions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        input: {
            padding: "1px",
            height: "7px"
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        root1: {
            // backgroundColor: "#fa4d83",

        }
    })
);

interface Props {
    uploadMediaFiles: any;
    mediaUpload: any;
    createRunPlan: any;
    getRunPlan: any;
    fetchRunPlan: any;
    loading: boolean;

}
const RunPlanData: React.FC<Props> = ({
    uploadMediaFiles,
    mediaUpload,
    createRunPlan,
    getRunPlan,
    fetchRunPlan,
    loading,

}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const [page, setPage] = useState(0);
    const { id } = useParams<{ id: string }>();
    const [name, setName] = useState<String>("");
    const [openModal, setopenModal] = useState<boolean>(false);
    const [runData, setRunData] = useState<any>("")
    const [failedMessage, setFailedMessage] = useState<any>("")
    const [uploading, setUploading] = useState<boolean>(false);
    const [fileKey, setFileKey] = useState<string>(Math.random().toString(36));
    const StyledTableCell: any = withStyles((theme: Theme) =>
        createStyles({
            head: {
                backgroundColor: "#12145e",
                color: theme.palette.common.white,
                fontSize: "14px",
            },
            body: {
                fontSize: 14,
            },
        })
    )(TableCell);

    const StyledTableRow: any = withStyles((theme: Theme) =>
        createStyles({
            root: {
                "&:nth-of-type(odd)": {
                    backgroundColor: theme.palette.action.hover,
                },
            },
        })
    )(TableRow);

    const handleClick = (data: any) => {
        setopenModal(true);
        setRunData(data);
    };
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = (fMessage: string) => {
        setFailedMessage(fMessage);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const fileSelectedHandler = async (e: React.ChangeEvent<{ files: any }>, type: any) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        setUploading(true);
        Api.post("/media", formData).then((data: any) => {
            setMediaFile({
                ...mediaFile,
                [type]: data?.path,
            })
            setUploading(false);
        }).catch(() => {
            setUploading(false);
        });
    };
    const [mediaFile, setMediaFile] = useState<any>({
        "runPlanFile": "",
    }
    );
    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        if (newPage > page) {
            let url = fetchRunPlan.links && fetchRunPlan.links.next.split("?")[1];
            getRunPlan(`?${url}`);
        } else if (newPage < page) {
            let url = fetchRunPlan.links && fetchRunPlan.links.previous.split("?")[1];
            getRunPlan(`${url === undefined ? "" : "?" + url}`);
        }
        setPage(newPage);
    };
    const handleAddSequence = async (e: any) => {
        e.preventDefault();
        const filterPath = mediaFile
        const runplandata = {
            file: filterPath?.runPlanFile,
            name: name,

        }
        await createRunPlan(runplandata);
        getRunPlan();
        setName("");
        setMediaFile("");
        setFileKey(Math.random().toString(36));
    };
    useEffect(() => {
        getRunPlan();

    }, [])
    return (
        <Grid container spacing={2}>
            <form onSubmit={handleAddSequence} style={{ width: "100%" }}>
                <Paper style={{ margin: "70px auto", width: "90%", marginTop: 60 }} className={classes.root1}>
                    <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Run Plan Validation</h2>
                    <Grid container spacing={2} style={{ marginLeft: 1 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <sup
                                style={{
                                    fontSize: "11px",
                                    marginLeft: "15px",
                                    marginTop: "15px",
                                    background: "#fff",
                                    color: "rgba(0, 0, 0, 0.54)",
                                    letterSpacing: "0.00938em",
                                }}
                            >
                                Upload File
                            </sup>
                            <input
                                className={classes.input}
                                style={{
                                    width: "100%",
                                    height: "58px",
                                    marginTop: "-15px",
                                    padding: "11.5px 14px",
                                    border: "1px solid rgba(0, 0, 0, 0.23)",
                                    borderRadius: "5px",
                                }}
                                accept=".xlsx"
                                type="file"
                                name="file"
                                id="file"
                                multiple
                                key={`${fileKey}qcreport`}
                                onChange={(e: any) => fileSelectedHandler(e, "runPlanFile")}

                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                id="name"
                                label="Name"
                                fullWidth
                                variant="outlined"
                                placeholder="Enter Name"
                                className={classes.input}
                                value={name}
                                style={{ height: "60px", marginTop: 6 }}
                                onChange={(e) => setName(e.target.value as String)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <Button
                                color="primary"
                                variant="contained"
                                disabled={uploading}
                                type="submit"
                                style={{ height: "55px", marginTop: 7 }}
                                fullWidth
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ width: "100%" }}>
                        <TableContainer className={classes.tableContainer} component={Paper} style={{ maxHeight: "490px" }}>
                            <Table stickyHeader aria-label="simple table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell align="center">Name</StyledTableCell>
                                        <StyledTableCell align="center">Date_Time</StyledTableCell>
                                        <StyledTableCell align="center">Orignal Run Plan</StyledTableCell>
                                        <StyledTableCell align="center">Invaild Index</StyledTableCell>
                                        <StyledTableCell align="center">Clash</StyledTableCell>
                                        <StyledTableCell align="center">Avoid</StyledTableCell>
                                        {/* <StyledTableCell align="center">Fail Status</StyledTableCell> */}
                                        <StyledTableCell align="center">Fail Reason</StyledTableCell>
                                        <StyledTableCell align="center">Run Log</StyledTableCell>
                                        <StyledTableCell align="center">Sample Sheet</StyledTableCell>
                                        <StyledTableCell align="center">Log File</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {fetchRunPlan && fetchRunPlan?.results?.length > 0 && fetchRunPlan?.results?.map((data: any, index: any) => {
                                        return (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell align="center">
                                                    {data?.name}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.createdAt !== null ? new Date(data?.createdAt).toLocaleString() : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.file !== "" ?
                                                        <a href={data?.file} download style={{ color: "green" }}><FileOpenIcon /></a>
                                                        : ""}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.mismatch}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.clash}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.avoid}
                                                </StyledTableCell>
                                                {/* <StyledTableCell>
                                                    <Button variant="outlined" onClick={() => handleClickOpen(data?.failReasonMessage)} style={{ background: data?.checkStatus === "Passed" ? "" : "#c60055" }} >
                                                        {data?.checkStatus}
                                                    </Button>
                                                </StyledTableCell> */}
                                                <StyledTableCell align="center">
                                                    {data?.failReason}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <div>
                                                        <MessageRounded
                                                            onClick={() => handleClick(data)}
                                                        />
                                                    </div>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <a href={data?.output} download style={{ color: "blue" }}><TaskIcon /></a>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <a href={data?.logFile} download style={{ color: "blueviolet" }}><InsertDriveFileIcon /></a>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                                <TableFooter>
                                    <TablePagination
                                        rowsPerPageOptions={[]}
                                        colSpan={3}
                                        count={fetchRunPlan?.count || 0}
                                        rowsPerPage={fetchRunPlan?.page_size}
                                        page={page}
                                        onPageChange={handleChangePage}
                                    />
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </div>
                </Paper>
            </form>
            <TicketCommentsModal
                openModal={openModal}
                setopenModal={setopenModal}
                rundata={runData}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <span style={{ color: "red" }}>{failedMessage}</span>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </Grid>
    );
};

const mapStateToProps = (state: any) => ({
    mediaUpload: state.GenomicsLabReducer.mediaUpload,
    fetchRunPlan: state.GenomicsLabReducer.fetchRunPlan,

});
export default connect(mapStateToProps, {
    uploadMediaFiles,
    createRunPlan,
    getRunPlan,

})(RunPlanData);
